import { Component, OnInit } from '@angular/core';
import { Http, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';
import { DurationPipe } from 'app/duration.pipe';

import {Observable} from 'rxjs/Observable'; // included for tests to run
import 'rxjs/add/operator/map'; // included for tests to run

declare var $: any;
declare var alertify: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  private Parse: any = require('parse');

  model: any = {};
  currentUser: any;
  hasPublicSessions: boolean = false;
  headers = new Headers();
  userId: string;

  constructor(
    public http: Http,
    public apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService
  ) {
    if (this.Parse.User.current()) {
      this.currentUser = this.Parse.User.current();
    }

    // Set the HTTP headers
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('X-Parse-Application-Id', environment.parse.appId);
    this.headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      this.headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }
  }

  ngOnInit() {
    this.loaderService.setLoading();

    let params = new URLSearchParams();
    let options = new RequestOptions();

    params.append('include', 'performanceState,statistics');

    options['headers'] = this.headers;
    options['params'] = params;

    this.route.params.subscribe(params => {
      if (params['id']) {
        this.userId = params['id'];
      } else {
        this.userId = this.apiService.Parse.User.current().id;
      }

      return this.http.get(this.apiService.Parse.serverURL + '/users/' + this.userId, options)
      .map(response => response.json()).subscribe(
        response => {
          // console.log(response);
          this.model = response;
        },
        error => {
          // console.log(error);
          switch (error.status) {
            case 404:
            this.router.navigateByUrl('/page-not-found', { skipLocationChange: true });
            break;
            default:
            this.router.navigateByUrl('/error', { skipLocationChange: true });
          }

          if (error.message) {
            alertify.error(error.message)
          }
        },
        () => {
          if (this.currentUser) {
            this.getFriendsList();
          }
          this.getSessionsList();
        });
    });
  }

  getFriendsList() {
    let params = new URLSearchParams();
    let options = new RequestOptions();

    // Configure the params to retrieve the following relations
    params.append("where", '{"$relatedTo":{"object":{"className":"_User","__type":"Pointer","objectId":"' + this.userId + '"},"key":"following"}}');

    options['headers'] = this.headers;
    options['params'] = params;

    // Get the friends list
    return this.http.get(this.apiService.Parse.serverURL + '/users', options)
      .map(response => response.json()).subscribe(
      response => {
        Object.assign(this.model.following, response);
      },
      // error => console.log(error),
      () => {}
      );
  }

  getSessionsList() {
    let params = new URLSearchParams();
    let options = new RequestOptions();

    // Update the params to include session summaries for the logged in user, and order them by start date
    params.append('include', 'sessionSummary');
    params.append('order', '-startDate');
    params.append('limit', '10');
    params.append("where", '{"user":{"className":"_User","objectId":"' + this.userId + '","__type":"Pointer"}}');

    options['headers'] = this.headers;
    options['params'] = params;

    // Get the session summaries
    this.http.get(this.apiService.Parse.serverURL + '/classes/RideSession', options)
      .map(response => response.json()).subscribe(
      response => {
        Object.assign(this.model, response);
        for (let i = 0; i < this.model.results.length; i++) {
          if (this.model.results[i].isPrivate == false) {
            this.hasPublicSessions = true;
            break;
          }
        }
        this.loaderService.setLoaded();
      },
      // error => console.log(error),
      () => {
        this.loaderService.setLoaded();
      }
    );
  }

  onClickSession(session) {
    this.router.navigate(['/session', session.objectId]);
  }

  onClickUser(userId) {
    this.router.navigate(['/home', userId]);
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/home/home.component.ts